import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';
import { forwardRef } from 'react';
import { withTestId } from '../../../../lib/testId.utils';

type Props = Pick<
  MuiTextFieldProps,
  | 'disabled'
  | 'error'
  | 'helperText'
  | 'label'
  | 'value'
  | 'onChange'
  | 'placeholder'
  | 'fullWidth'
  | 'className'
  | 'sx'
  | 'slotProps'
  | 'autoFocus'
  | 'name'
  | 'id'
  | 'multiline'
  | 'rows'
  | 'maxRows'
  | 'minRows'
  | 'type'
  | 'required'
  | 'autoComplete'
  | 'onBlur'
  | 'onFocus'
  | 'onKeyDown'
  | 'onKeyUp'
  | 'size'
> & {
  testId?: string;
};

const TextField = forwardRef<HTMLInputElement | HTMLTextAreaElement, Props>(
  (
    {
      size = 'medium',
      fullWidth = true,
      disabled,
      error,
      helperText,
      label,
      value,
      onChange,
      placeholder,
      className,
      sx,
      slotProps,
      autoFocus,
      name,
      id,
      multiline,
      rows,
      maxRows,
      minRows,
      type,
      required,
      autoComplete,
      onBlur,
      onFocus,
      onKeyDown,
      onKeyUp,
      testId,
    },
    ref,
  ) => {
    return (
      <MuiTextField
        variant="outlined"
        size={size}
        fullWidth={fullWidth}
        inputRef={ref}
        disabled={disabled}
        error={error}
        helperText={helperText}
        label={label}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        sx={sx}
        slotProps={withTestId(slotProps, 'htmlInput', testId)}
        autoFocus={autoFocus}
        name={name}
        id={id}
        multiline={multiline}
        rows={rows}
        maxRows={maxRows}
        minRows={minRows}
        type={type}
        required={required}
        autoComplete={autoComplete}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
      />
    );
  },
);

TextField.displayName = 'TextField';
export type { Props as TextFieldProps };
export default TextField;
